import { type FC } from 'react'
import { type UseFormReturn } from 'react-hook-form'
import { FormattedMessage } from 'react-intl'

import { Checkbox, FormHelperText } from 'base-ui'

import { type MarketplacePartnerRegisterPageFormV3Values } from '../../../hooks/marketplacePartnerRegisterPageFormV3RHFModel'
import { type MarketplacePartnerRegisterPageDictionaryOption } from '../../../hooks/useMarketplacePartnerRegisterPageGetDictionaryOptionsByName'

type MarketplacePartnerRegisterPageFormV3TargetCountriesProps = {
  form: UseFormReturn<MarketplacePartnerRegisterPageFormV3Values>
  targetCountriesOptions: MarketplacePartnerRegisterPageDictionaryOption[]
  targetCountryValues: string[]
  toggleTargetCountry: (value: string, checked: boolean) => void
}

export const MarketplacePartnerRegisterPageFormV3TargetCountries: FC<
  MarketplacePartnerRegisterPageFormV3TargetCountriesProps
> = ({
  form,
  targetCountriesOptions,
  targetCountryValues,
  toggleTargetCountry,
}) => {
  return (
    <div className="flex flex-col gap-4">
      <span className="text-l">
        <FormattedMessage id="marketplacePartnerRegisterPage.v3.targetCountries.label" />
      </span>
      {form.formState.errors.targetCountries?.message ? (
        <FormHelperText
          data-qa-id="global-MessageForm-targetCountries-error-msg"
          error
        >
          {form.formState.errors.targetCountries.message}
        </FormHelperText>
      ) : null}
      <div className="flex flex-wrap gap-5">
        {targetCountriesOptions.map((option) => {
          const checked = targetCountryValues.includes(option.key)

          return (
            <label className="flex items-center gap-2" key={option.key}>
              <Checkbox
                checked={checked}
                data-qa-id={`sellerForm-checkbox-target-country-${option.key}`}
                onChange={(event): void => {
                  toggleTargetCountry(option.key, event.target.checked)
                }}
              />
              <span>{option.label}</span>
            </label>
          )
        })}
      </div>
    </div>
  )
}
